import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import countries from 'i18n-iso-countries';

// Lazy-load country locale files for Vite compatibility
const countryLocales = import.meta.glob('/node_modules/i18n-iso-countries/langs/*.json');

// Helper to get country locale by language code
function getCountryLocale(lang) {
    const key = `/node_modules/i18n-iso-countries/langs/${lang}.json`;
    return countryLocales[key]?.() ?? Promise.reject(`Unknown language (${lang}) specified`);
}

i18n.use(intervalPlural)
    .use(LanguageDetector)
    .use({
        // custom loading backend to avoid cache problems by exploiting vite bundle hashing.
        type: 'backend',
        read(language, namespace, callback) {
            let lang = language.split('-')[0];

            getCountryLocale(lang)
                .catch(err => {
                    console.error(`Country locale not found for ${lang}, falling back to en`);
                    return getCountryLocale('en');
                })
                .then(
                    langFile => {
                        if (langFile) {
                            countries.registerLocale(langFile);
                        }

                        return import(`../locales/${language}/${namespace}.json`);
                    },
                    err => console.error(err)
                )
                .then(
                    res => {
                        callback(null, res.default);
                    },
                    err => {
                        callback(err, null);
                    }
                );
        }
    })
    .use(initReactI18next)
    .init({
        load: 'currentOnly',
        fallbackLng: {
            // defined fallback by priority according to position in array
            // if key is not found in first language it will look for it in the next until it finds a match (en-GB is the default fallback)
            'en-CA': ['en-US', 'en-GB'],
            'en-US': ['en-GB'],
            'es-ES': ['en-GB'],
            'fr-CA': ['fr-FR', 'en-GB'],
            'fr-CH': ['fr-FR', 'en-GB'],
            'fr-FR': ['en-GB'],
            'it-IT': ['en-GB'],
            'de-CH': ['de-DE', 'en-GB'],
            'de-DE': ['de-CH', 'en-GB'],
            'nl-BE': ['nl-NL', 'en-GB'],
            'nl-NL': ['en-GB'],
            eu: ['fr-FR'], // fallback for unhandled bo language
            br: ['fr-FR'], // fallback for unhandled bo language
            default: ['en-GB'] // handle case where language is not defined in the list above
        },
        ns: 'index',
        defaultNS: 'index',
        interpolation: {
            escapeValue: false,
            prefix: '%',
            suffix: '%'
        },
        react: {
            useSuspense: true,
            transSupportBasicHtmlNodes: true
        },
        debug: import.meta.env.MODE !== 'production'
    });

export const aliases = {
    'FR-fr': 'fr-FR',
    fr: 'fr-FR',
    en: 'en-GB',
    es: 'es-ES',
    it: 'it-IT'
};

window.i18n = i18n;
export default i18n;
